import React from 'react'
import PropTypes from 'prop-types'
import { SortableHandle } from 'react-sortable-hoc'
import { IconButton } from '@material-ui/core'
import clsx from 'clsx'
import GripVertical from '@v4/components/common/FAIcons/Solid/GripVertical'
import useStyles from './DragHandle.styled'

const DragHandle = props => {
	const { className, disabled } = props
	const classes = useStyles(props)

	return (
		<IconButton
			className={clsx(className, classes.root, 'drag-handle')}
			disabled={disabled}
			component="span"
			disableRipple
		>
			<GripVertical />
		</IconButton>
	)
}

DragHandle.propTypes = {
	className: PropTypes.string,
	disabled: PropTypes.bool,
}

export default SortableHandle(DragHandle)
